import React, { useEffect, useRef, useContext } from "react";
import { parse } from "qs";
import { routeUrls } from "../../../config/routeUrls";
import ApplicationFallback from "../../../components/applicationFallback/ApplicationFallback";
import settings from "../../../settings";
import { authService } from "../../../api/authService/authService";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/authContext";
import { IAuthContext } from "../../../types/auth";


const LoginCallback: React.FC = () => {
    const navigate = useNavigate();
    const { login } = useContext(AuthContext) as IAuthContext;

    const canGo = useRef(true);
    useEffect(() => {
        if (canGo.current) {
            canGo.current = false;

            const { code } = parse(window.location.search, { ignoreQueryPrefix: true });
            const codeVerifier = window.sessionStorage.getItem('codeVerifier');

            if (!code || !codeVerifier) {
                window.location.href = routeUrls.authorize;
            }

            authService.getToken(code, window.location.origin + routeUrls.loginCallback, "authorization_code", settings.clientId, codeVerifier, data => {
                if (data.success) {
                    const tokenData = JSON.parse(data.responseBody.token);
                    window.sessionStorage.setItem('accessToken', tokenData.access_token);
                    window.sessionStorage.setItem('idToken', tokenData.id_token);
                    
                    // Salva anche il refresh token se presente
                    if (tokenData.refresh_token) {
                        window.sessionStorage.setItem('refreshToken', tokenData.refresh_token);
                        console.log('Refresh token saved for silent refresh');
                    } else {
                        console.warn('No refresh_token found in response');
                    }

                    // Salva anche la scadenza se presente
                    if (tokenData.expires_in) {
                        const now = Math.floor(Date.now() / 1000);
                        const expirationTime = now + tokenData.expires_in;
                        window.sessionStorage.setItem('tokenExpiration', expirationTime.toString());
                        console.log('Token expiration saved:', new Date(expirationTime * 1000));
                    } else {
                        console.warn('No expires_in found in response');
                    }

                    window.sessionStorage.setItem('accountId', data.responseBody.accountId);
                    window.sessionStorage.setItem('contactId', data.responseBody.contactId);

                    login();

                    const redirectUrl = sessionStorage.getItem("redirectUrl") || routeUrls.dashboard;
                    console.log("LoginCallback: Redirecting to:", redirectUrl);
                    navigate(redirectUrl);
                    sessionStorage.removeItem("redirectUrl");
                } else {
                    navigate(routeUrls.authorizeError);
                }
            }, () => {
                navigate(routeUrls.authorizeError);
            });
        }
    }, []);

    return (
        <ApplicationFallback />
    )
}

export default LoginCallback;